import React, { useState, useEffect, useMemo } from "react";

import { Button } from "@transfr-inc/dashboard-components/forms";
import { CourseGradebookFilterModal } from "@components/modals";

import "./classroom-gradebook.filter.scss";
export const CourseGradebookFilter = ({
  onApplyFilters,
  gradebookData,
  defaultUnit,
  selectedUser,
}) => {
  const [openFilterModal, setOpenFilterModal] = useState();
  const [filterCount, setFilterCount] = useState(1);

  const onUpdateFilterCount = (count) => {
    setFilterCount(count);
  };

  const onApplyFiltersHandler = (filters) => {
    const unitData = gradebookData.get(filters.unit.unitId);
    const isVirtualUnit = filters.unit?.isVirtualUnit ?? false;
    
    const lessons =
      filters.lessons.length > 0
        ? filters.lessons
        : unitData?.lessons || [];
    
    const trainees =
      filters.users.length > 0
        ? filters.users
        : unitData?.users;
    const filtersObject = {
      unit: filters.unit,
      lessons: lessons,
      users: trainees,
    };

    onApplyFilters && onApplyFilters(filtersObject);
    setOpenFilterModal();
  };

  const mappedSelectedUser = useMemo(() => {
    if (!selectedUser || !defaultUnit) return null;
    return gradebookData
      .get(defaultUnit.unitId)
      ?.users.find((user) => user.id === selectedUser);
  }, [defaultUnit, selectedUser]);

  useEffect(() => {
    if (defaultUnit) {
      const filtersToApply = {
        unit: defaultUnit,
        lessons: [],
        users: [],
      };

      if (mappedSelectedUser) {
        filtersToApply.users = [mappedSelectedUser];
      }

      onApplyFiltersHandler(filtersToApply);
    }
  }, [defaultUnit, selectedUser, mappedSelectedUser]);

  return (
    <>
      <div className="classroom-gradebook-filter-container">
        <Button
          icon={["fa-regular", "sliders"]}
          onClick={() => setOpenFilterModal(true)}
        >
          Filters
          {filterCount > 0 && <span className="badge">{filterCount}</span>}
        </Button>
      </div>
      <CourseGradebookFilterModal
        open={openFilterModal}
        onCancel={() => setOpenFilterModal()}
        onApplyFilters={onApplyFiltersHandler}
        onUpdateFilterCount={onUpdateFilterCount}
        gradebookData={gradebookData}
        defaultUnit={defaultUnit}
        selectedUser={mappedSelectedUser}
      />
    </>
  );
};
